import React from 'react'
import styled from 'styled-components'
import JobOffersQuerySelectModal from '../JobOffersQuerySelectModal'
import SearchConditionDropdown from '../SearchConditionDropdown'
import { StyledSearchConditionDropdownProps } from '../SearchConditionDropdown/styled'

export type SearchConditionModalProps = {
  name: string,
  modalTitle: string,
  categoryGroups: StyledSearchConditionDropdownProps[],
  count: number,
  columns: number,
  dataCy?: string,
  onSubmit: () => void,
  onClose: () => void,
}

const StyledUl = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const StyledCategorizedQuerySearchConditionModal: React.FC<SearchConditionModalProps> = (props: SearchConditionModalProps) => {
  return (
    <JobOffersQuerySelectModal modalTitle={props.modalTitle} count={props.count} dataCy={props.dataCy} onSubmit={props.onSubmit} onClose={props.onClose}>
      <StyledUl>
        {props.categoryGroups.map((group: StyledSearchConditionDropdownProps, index: number) => {
          return (
            <li key={index}>
              <SearchConditionDropdown
                header={group.header}
                options={group.options}
                groupedOptions={group.groupedOptions}
                columns={props.columns}
              />
            </li>
          )
        })
        }
      </StyledUl>
    </JobOffersQuerySelectModal>
  )
}
